module.exports = __webpack_public_path__ + "img/drag-direc.bf556d2d.png";